module.exports = __webpack_public_path__ + "static/media/Home 2new loanx3.7725716f.svg";